import React from 'react';
import { Redirect } from 'react-router'
import firebase from 'firebase';
import firebaseui from 'firebaseui';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.auth = firebase.auth();
  }

  componentDidMount = () => {
    var redirectLoc = "/";
    if (this.props.location.state.from) {
      redirectLoc = this.props.location.state.from.pathname;
    }

    // Initialize the FirebaseUI Widget using Firebase.
    const  ui = this.props.fui;

    // FirebaseUI config.
    var uiConfig = {
      callbacks: {
        signInSuccess: function(currentUser, credential, redirectUrl) {
          this.props.signInSuccessFunc(currentUser, redirectLoc);
          return false;
        }
      },
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      tosUrl: '/terms',
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      queryParameterForWidgetMode: 'mode',
    };

    // The start method will wait until the DOM is loaded.
    ui.start('#firebaseui-auth-container', uiConfig);
  }

  render = () => {
    const { from } = this.props.location.state || '/'
    if (this.props.isAuthenticated()) {
      return (
        <div className="app-content">
          <Redirect to={from || '/'}/>
        </div>
      );
    }else{
      return (
        <div className="app-content app-content-margins">
          <div id="firebaseui-auth-container">
          </div>
        </div>
      );
    }
  }
}

Login.propTypes = {
  signInSuccessFunc: React.PropTypes.func.isRequired,
  isAuthenticated: React.PropTypes.func.isRequired,
  location: React.PropTypes.object,
  fui: React.PropTypes.object,
}

export default Login



// WEBPACK FOOTER //
// ./src/components/login/Login.js